import React from 'react'

const Manual_cloudbeds_conexion_invu = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">Cloudbeds - Conexión de Integración con InvuPOS</h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo conectar Cloudbeds con InvuPOS de forma simple y segura, resaltando pasos clave y medidas de protección para optimizar la gestión del negocio.
        </p>
        <iframe
          src="https://scribehow.com/embed/Cloudbeds__Conexion_de_Integracion_con_InvuPOS__TrHpZJAHRcmranh8K30SRw?as=scrollable"
          className="scribe-iframe-general-200"
          width="100%" 
          height="4200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_cloudbeds_conexion_invu
